
import { useEffect, useRef } from "react";
import { msalInstance } from "./authConfig"; // Your MSAL configuration file

const useAutoLogout = (timeout = 30 * 60 * 1000) => { // Default 5 minutes
    const timeoutRef = useRef(null);

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            handleLogout();
        }, timeout);
    };

    const handleLogout = async () => {
        try {
            console.log("User is idle, logging out...");
            
            // Ensure MSAL is initialized
            await msalInstance.initialize();
            
            // Clear local storage
            localStorage.clear();
    
            // Perform logout and redirect
            // await msalInstance.logoutRedirect({
            //     postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`,
            // });
    
            // Reload the application after logout
            window.location.reload();
        } catch (error) {
            console.error("MSAL logout failed:", error);
    
            // Fallback: If logout fails, clear storage and reload anyway
            localStorage.clear();
            window.location.reload();
        }
    };
    
    

    useEffect(() => {
        const activityEvents = ["mousemove", "keydown", "mousedown", "touchstart"];

        const handleActivity = () => resetTimer();

        activityEvents.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );

        resetTimer(); // Initialize timer on component mount

        return () => {
            clearTimeout(timeoutRef.current); // Clear timeout on unmount
            activityEvents.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
        };
    }, [timeout]);

    return null; // Hook does not render anything
};

export default useAutoLogout;
